import script from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"
export * from "./NuovaRilevazione.vue?vue&type=script&setup=true&lang=js"

import "./NuovaRilevazione.vue?vue&type=style&index=0&id=7820be7c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7820be7c"]])

export default __exports__